<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>             

          <b-form>
            <b-form-group
              label="Nro. Cheque"
              label-for="chequePropioNumero"
              :label-cols="labelCols"
              horizontal
              description="Ingrese el número de cheque propio y haga click en el botón de búsqueda">
              <b-input-group>
                <b-form-input 
                  id="chequePropioNumero"
                  class="number-input"
                  v-model.number="chequePropioNumero" 
                  type="number"
                  @focus="$event.target.select()"
                  @keyup.enter="getChequePropio"/>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="getChequePropio">
                  <b-input-group-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            
            <br>

            <b-form-group
              label="Proveedor"
              label-for="proveedor"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="proveedor" 
                :value="proveedor" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Importe"
              label-for="importe"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importe" 
                :value="importe | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="anularDevolucion">Anular</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="close">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';

export default {
  name: 'AnulacionDevolucion',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  props: {
    bancoCuentaId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      chequePropioNumero: 0,
      chequePropio: null,

      labelCols: 2,
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',
    }
  },
  computed: {
    proveedor() {
      if (this.chequePropio) {
        if (this.chequePropio.proveedor) {
          return this.chequePropio.proveedor.trim();
        }
      }
      return '';
    },
    importe() {
      if (this.chequePropio) {
        if (this.chequePropio.importe) {
          return this.chequePropio.importe;
        }
      }
      return 0;
    },
  },  
  created() {
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(alertMsj, alertVariant) {
      this.alertMsj = alertMsj;
      this.alertVariant = alertVariant;
      this.dismissCountDown = this.alertCountDown;
    },
    getChequePropio() {
      let params = {
        bancoCuentaId: this.bancoCuentaId,
        bancoMovimientoTipoId: 1,
        numero: parseInt(this.chequePropioNumero)
      }
      
      this.chequePropio = null;

      this.$store.dispatch('bancomovimiento/getBancoMovimientoDatosByNumero', params)
        .then(() => this.chequePropio = this.$store.getters['bancomovimiento/bancoMovimiento'])
        .catch(error => this.showAlert(error, 'danger'));
    },
    anularDevolucion () {
      let anular = Boolean(true);

      
      if (this.chequePropioNumero == 0) {
        this.showAlert('Ingrese los datos del cheque correspondiente', 'danger');
        anular = false;
      }

      let chequePropioError = true;
      if (this.chequePropio) {
        if (this.chequePropio.id != 0) {
          chequePropioError = false;
        }
      }

      if (chequePropioError) {
        this.showAlert('Ingrese los datos del cheque correspondiente', 'danger');
        anular = false;
      }

      if (anular) {
        this.showModalConfirm('¿Desea anular la devolución del cheque propio seleccionado?', 
              this.anular, 'Si', null, 'No')
      }
    },
    anular() {
      let chequePropioId = this.chequePropio.id;

      this.showSpinner();
      this.$store.dispatch('bancosmovimientos/anularDevolucionChequePropio', chequePropioId)
        .then(() => this.$emit('close', true))
        .catch( error => this.showAlert(error, 'danger'))
        .finally(() => this.hideSpinner())
    },
    close() {
      this.$emit('close', false);
    },
  },
  watch: {
  },
}
</script>

<style>
</style>
